import Vue from 'vue'
import Aside from 'element-ui/lib/aside'
import Breadcrumb from 'element-ui/lib/breadcrumb'
import BreadcrumbItem from 'element-ui/lib/breadcrumb-item'
import Button from 'element-ui/lib/button'
import Card from 'element-ui/lib/card'
import Carousel from 'element-ui/lib/carousel'
import CarouselItem from 'element-ui/lib/carousel-item'
import Checkbox from 'element-ui/lib/checkbox'
import Container from 'element-ui/lib/container'
import Dialog from 'element-ui/lib/dialog'
import Empty from 'element-ui/lib/empty'
import Form from 'element-ui/lib/form'
import FormItem from 'element-ui/lib/form-item'
import Header from 'element-ui/lib/header'
import Image from 'element-ui/lib/image'
import Input from 'element-ui/lib/input'
import InputNumber from 'element-ui/lib/input-number'
import Loading from 'element-ui/lib/loading'
import Main from 'element-ui/lib/main'
import Message from 'element-ui/lib/message'
import MessageBox from 'element-ui/lib/message-box'
import Option from 'element-ui/lib/option'
import Pagination from 'element-ui/lib/pagination'
import RadioButton from 'element-ui/lib/radio-button'
import RadioGroup from 'element-ui/lib/radio-group'
import Select from 'element-ui/lib/select'
import TabPane from 'element-ui/lib/tab-pane'
import Table from 'element-ui/lib/table'
import TableColumn from 'element-ui/lib/table-column'
import Tabs from 'element-ui/lib/tabs'
import Tag from 'element-ui/lib/tag'
import Tooltip from 'element-ui/lib/tooltip'
import Upload from 'element-ui/lib/upload'

import 'element-ui/lib/theme-chalk/index.css'

const components = [
  Aside,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  Carousel,
  CarouselItem,
  Checkbox,
  Container,
  Dialog,
  Empty,
  Form,
  FormItem,
  Header,
  Image,
  Input,
  InputNumber,
  Main,
  Option,
  Pagination,
  RadioButton,
  RadioGroup,
  Select,
  TabPane,
  Table,
  TableColumn,
  Tabs,
  Tag,
  Tooltip,
  Upload
]

components.forEach((component) => {
  Vue.component(component.name, component)
})

Vue.use(Loading)
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
